import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormContactsComponent } from './form-contacts.component';
import { InputModule } from '../input/input.module';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [FormContactsComponent],
  imports: [CommonModule, ButtonModule, InputModule, TranslateModule],
  exports: [FormContactsComponent],
})
export class FormContactsModule {}
